import React from 'react'
import style from './ProductosComp.module.css'
import imagen1 from '../../../utils/images/box-1.png'
import imagen2 from '../../../utils/images/box-2.png'
import imagen3 from '../../../utils/images/box-3.png'
import imagen4 from '../../../utils/images/box-4.png'
import imagen5 from '../../../utils/images/box-5.png'
import imagen6 from '../../../utils/images/box-6.png'
import imagen7 from '../../../utils/images/box-7.png'
//import imagen8 from '../../../utils/images/box-8.png'
//import imagen9 from '../../../utils/images/box-9.png'
import imagen10 from '../../../utils/images/box-10.png'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import CardProductos from '../../generales/CardProductos'

const ProductosComp = () => {
    const [t] = useTranslation();

    return (
        <div className={style.productos}>
            <div className={style.divCards}>
                <div className={style.cards1}>
                    <CardProductos
                        imagen={imagen4}
                        link={"/productos/ssc-enterprise"}
                        title={"HomePage.Products.supervision-and-control-system"}
                        text={"HomePage.Products.description-of-supervision-and-control-system"}
                    />
                    <CardProductos
                        imagen={imagen7}
                        link={"/productos/Smartsuite"}
                        title={"HomePage.Products.smartsuite"}
                        text={"HomePage.Products.description-of-smartsuite"}
                    />
                </div>
                <div className={style.cards2}>
                    <CardProductos
                        imagen={imagen1}
                        link={"/productos/business-solution"}
                        title={"HomePage.Products.business-solution"}
                        text={"HomePage.Products.description-of-business-solution"}
                    />
                    <CardProductos
                        imagen={imagen6}
                        link={"/productos/geontracker"}
                        title={"HomePage.Products.geontracker"}
                        text={"HomePage.Products.description-of-geontracker"}
                    />                    
                </div>
                <div className={style.cards2}>
                    <CardProductos
                        imagen={imagen3}
                        link={"/productos/factory-scada"}
                        title={"HomePage.Products.factory-scada"}
                        text={"HomePage.Products.description-of-factory-scada"}
                    />
                    <CardProductos
                        imagen={imagen2}
                        link={"/productos/evo-scada-server"}
                        title={"HomePage.Products.evo-scada-server"}
                        text={"HomePage.Products.description-of-evo-scada-server"}
                    />                    
                </div>
                {/*<div className={style.cards2}>
                    <CardProductos
                        imagen={imagen8}
                        link={"/productos/smartiot"}
                        title={"HomePage.Products.smartiot"}
                        text={"HomePage.Products.description-of-smartiot"}
                    />
                    <CardProductos
                        imagen={imagen9}
                        link={"/productos/Smartssc"}
                        title={"HomePage.Products.SmartSSC"}
                        text={"HomePage.Products.description-of-smartscc"}
                    />                    
                </div>*/}                
                <div className={style.cards2}>
                    <CardProductos
                        imagen={imagen10}
                        link={"/productos/syncflow"}
                        title={t("HomePage.Products.syncflow")}
                        text={t("HomePage.Products.description-of-syncflow")}
                    />
                    <CardProductos
                        imagen={imagen5}
                        link={"/productos/interactive-voice-response"}
                        title={"HomePage.Products.interactive-voice-response"}
                        text={"HomePage.Products.description-of-interactive-voice-response"}
                    />                    
                    {/* <CardProductos
                        imagen={imagen6}
                        link={"/productos/whatsapp-bot"}
                        title={"HomePage.Products.whatsapp-bot"}
                        text={"HomePage.Products.description-of-whatsapp-bot"}
                    /> */}
                </div>
            </div>
            <div className={style.otrosProductos}>
                <div className={style.divTextProd}>
                    <p className={style.textProd1}>{t("HomePage.Products.not-what-you're-looking-for?")}</p>
                    <p className={style.textProd2}>{t("HomePage.Products.we-can-develop-what-you-need")}</p>
                </div>
                <div className={style.divButtonProd}>
                    {/* <Link className={style.link} to='/productos'>
                        <div className={style.verProductos}>{t("HomePage.Products.buttonName1")}</div>
                    </Link>*/}
                    <Link className={style.link} to='/contacto'>
                        <div className={style.verProductos}>{t("HomePage.Products.buttonName2")}</div>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default ProductosComp